import React from 'react';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classes from './LearningTrackingMain.module.css'
import StudentsLayout from '../../../assests/learning-tracking/main-page/students-layout.png'
import Assessments from '../../../assests/learning-tracking/main-page/assessments.png'
import StudentTracking from '../../../assests/learning-tracking/main-page/student-tracking.png'
import ViewLesson from '../../../assests/learning-tracking/main-page/view-lesson.png'
import Teams from '../../../assests/learning-tracking/main-page/teams.png'
import * as PathRouter from '../../../models/PathRoute'
import { onKeyDown } from '../../../service';



const LearningTrackingMain = () => {
    const texts = useSelector(state => state.translate.texts);
    const navigate = useNavigate();

    const handleCircleClick = (goTo) => {
        navigate(`../${goTo}`)
    }

    let mainInfo = [
        {
            goTo: `${PathRouter.STUDENTS_LAYOUT}/0`,
            icon: StudentsLayout,
            text: texts.studentsLayout,
            background: "linear-gradient(180deg, #F68E68 0%, #F2AD24 100%)",
        },
        {
            goTo: `${PathRouter.ASSESSMENTS}/0`,
            icon: Assessments,
            text: texts.checkAssessments,
            background: "linear-gradient(180deg, #67E7EB 0%, #9AEADE 100%)",
        },
        {
            goTo: `${PathRouter.STUDENT_TRACKING}/0`,
            icon: StudentTracking,
            text: texts.studentTracking,
            background: "linear-gradient(180deg, #0E3F79 0%, #1692B9 100%)",
        },
        {
            goTo: `${PathRouter.LESSON}/0`,
            icon: ViewLesson,
            text: texts.viewLessonAndStudySubjects,
            background: "linear-gradient(202.1deg, #2D8150 19.78%, #199775 85.56%)",
        },
        {
            goTo: `${PathRouter.TEAMS}/0`,
            icon: Teams,
            text: texts.divisionIntoTeams,
            background: "linear-gradient(202.1deg, #F668BD 19.78%, #F22493 85.56%)",
        }
    ]

    return (
        <div className={classes.Main}>
            <div className={classes.Title}>{texts.learningTrackingMainTitle}</div>
            <div className={classes.Items}>
                {mainInfo.map((info, index) =>
                    <div className={classes.Item} key={index}>
                        <div className={classes.Circle} style={{ background: info.background }} onClick={() => handleCircleClick(info.goTo)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleCircleClick(info.goTo))}>
                            <img src={info.icon} className={classes.Icon} alt="icon" />
                        </div>
                        <h3 className={classes.Text}>{info.text}</h3>
                    </div>
                )}
            </div >
        </div >
    )
}

export default LearningTrackingMain;